import { createAction, props } from '@ngrx/store';
import { Report, ReportObject } from '../models/report.model';
import { PartData } from '@shared/gui/models/part-data.model';
import { TimestreamMetric } from '@app/home/models/metric.model';

// init

export const loadReportsSuccess = createAction(
  '[Report] Load successfully the user reports',
  props<{ historics: Array<Report>; favorites: Array<Report> }>()
);
export const loadReportsError = createAction('[Report] Load past reports failure');

// core

export const resetState = createAction('[Report] Reset state instruction');
export const resetStateApply = createAction('[Report] Apply reset state once preprocess is done');

// manage panels

export const toggleProperties = createAction('[Report] toggle report property panel');

// set report object list

export const addItems = createAction('[Report] Add objects to the report', props<{ items: Array<PartData> }>());
export const removeItems = createAction(
  '[Report] Remove objects from the report',
  props<{ items: Array<ReportObject> }>()
);
export const updateProperties = createAction(
  '[Report] update report object properties',
  props<{ objects: Array<ReportObject> }>()
);
export const resetReport = createAction('[Report] Reset report to its empty form');
export const updatePreview = createAction('[Report] patch existing report configuration', props<{ report: Report }>());
export const loadReport = createAction('[Report] load existing report configuration', props<{ report: Report }>());
export const loadReportSuccess = createAction('[Report] load report with part data', props<{ report: Report }>());

// generation

export const generateReport = createAction('[Report] start generating the report', props<{ report: Report }>());
export const storeReport = createAction('[Report] store generating report in process', props<{ report: Report }>());
export const generateReportReceived = createAction(
  '[Report] generated report returned over signalR',
  props<{ file: Blob }>()
);
export const generateReportSuccess = createAction(
  '[Report] process the downloaded report',
  props<{ report: Report }>()
);
export const generateReportError = createAction('[Report] report generation failure');

// favorite

export const favoriteReport = createAction('[Report] favorite a report', props<{ report: Report }>());
export const updateReportList = createAction('[Report] update a report data from list', props<{ report: Report }>());
export const removeReport = createAction('[Report] remove a report from lists', props<{ report: Report }>());

// curve preview

export const togglePreview = createAction('[Report] toggle preview window for current report');
export const loadPreview = createAction(
  '[Report] load preview data for current report',
  props<{ data: Array<TimestreamMetric> }>()
);
